import { getEkardoApolloClient, NETFRONT_PRODUCT_QUICKCODES } from '@netfront/common-library';
import {
  IDBContentGroup,
  ISearchContentGroupsQueryGraphQLResponse,
  ISearchContentGroupsQueryVariables,
  SEARCH_CONTENT_GROUPS_QUERY,
} from '@netfront/ekardo-content-library';
import { NextPage } from 'next';

import { DocsLandingPage } from '../../components';
import { STATIC_PAGE_REGENERATION_TIME_IN_SECONDS } from '../../constants';

interface DocsLandingNextPageProps {
  contentGroups: IDBContentGroup[];
}

const DocsLandingNextPage: NextPage<DocsLandingNextPageProps> = ({ contentGroups }) => {
  return <DocsLandingPage contentGroups={contentGroups} />;
};

export async function getStaticProps() {
  const client = getEkardoApolloClient({
    product: NETFRONT_PRODUCT_QUICKCODES,
  });

  const {
    data: {
      contentGroup: { searchContentGroups: contentGroups },
    },
  } = await client.query<ISearchContentGroupsQueryGraphQLResponse, ISearchContentGroupsQueryVariables>({
    query: SEARCH_CONTENT_GROUPS_QUERY,
    variables: {
      projectId: String(process.env.REACT_APP_PROJECT_ID),
      type: 'HELP',
    },
  });

  const sortedGroups = [...contentGroups].sort((a, b) => a.sort - b.sort);

  return {
    props: {
      contentGroups: sortedGroups,
    },
    revalidate: STATIC_PAGE_REGENERATION_TIME_IN_SECONDS,
  };
}

// eslint-disable-next-line import/no-default-export
export default DocsLandingNextPage;
